import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const adminQrApi = createApi({
    reducerPath: 'adminQrApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API,
        prepareHeaders: (headers) => {
            const user = localStorage.getItem('hthUser');
            const token = user ? JSON.parse(user).token : null;
            if (token) {
                headers.set('authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getQr: builder.query({
            query: () => '/api/admin/getQr',
        }),
        addQr: builder.mutation({
            query: (data) => ({
                url: '/api/admin/addQr',
                method: 'POST',
                body: data,
            }),
        }),
    }),
});

export const {
    useGetQrQuery,
    useAddQrMutation,
} = adminQrApi;
